import { useForm } from 'react-hook-form';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useUserLabelStore } from '@shared/hooks/useUserLabelStore';

interface FormData {
  label: string;
}

interface Props {
  open: boolean;
  onComplete: () => void;
}

export default function UserLabelModal({ open, onComplete }: Props) {
  const setLabel = useUserLabelStore((s) => s.setLabel);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    setLabel(data.label);
    onComplete();
  };

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle>User Identification</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
            User label is required for auditability. Enter your name or identifier.
          </Typography>
          <TextField
            {...register('label', {
              required: 'Label is required',
              minLength: { value: 2, message: 'Min 2 characters' },
            })}
            label="User Label"
            fullWidth
            autoFocus
            error={!!errors.label}
            helperText={errors.label?.message}
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained">
            Continue
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
